let inflightFetchCount = 0;
export const getInflightFetchCount = () => inflightFetchCount;
export const sendEventsViaFetch = (endpoint, {
  data
}) => {
  const fetchPromise = fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  });
  inflightFetchCount++;

  // We don't care about it throwing or not, as if it throws
  // it should bubble up to the caller of sendEventsViaFetch
  // eslint-disable-next-line promise/catch-or-return
  fetchPromise.finally(() => inflightFetchCount--);
  return fetchPromise;
};